import React from 'react';
import '../../styles/main.scss';
import uploadlogo from "../images/upload_logo.svg";
import Logout from "../images/logo_logout.svg";
import ThemeToggle from '../common/ThemeToggle';

const Header = () => {
  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.history.replaceState(null, '', '/login');
    window.location.href = '/login';
  };

  return (
    <>
      <header className="header">
        <div className="header-logo">
          <img src={uploadlogo} alt="logo" />
        </div>


        <div className="header-actions">
          <ThemeToggle />
          <button className="logout-btn" onClick={handleLogout}>
            <img src={Logout} alt="logout" />
            <span>Logout</span>
          </button>
        </div>
      </header>
    </>
  );
};

export default Header;